import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RefreshBubbleProps {
  visible: boolean;
  onClick: () => void;
}

export function RefreshBubble({ visible, onClick }: RefreshBubbleProps) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-full shadow-lg text-sm font-medium hover:bg-primary/90 transition-all animate-in slide-in-from-top-2"
    >
      <RefreshCw className="h-3.5 w-3.5" />
      {t('refreshBubble.newTasksAvailable')}
    </button>
  );
}
